import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'content-blocks'
const verb = 'post'

export default class OspreyContentBlocksTagsApply extends BaseAction {
    constructor(dataKey) {
        const id = '1c3efce2-2a13-4bdb-8a33-850f1c80ab2a'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    applyTagToContentblock(params) {
        const { contentBlockId, tagIdList } = params

        this.path = `/${resource}/${contentBlockId}/tags`

        this.params = {
            tagIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/content-blocks/content-blocks-tags-apply.js